<template>
  <div>
    Only authenticated users see this
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {
  },
  data() {
    return {
     
    };
  },
  created() {
   
  }
};
</script>

<style scoped lang="scss">

</style>
